import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { SafeSvgDirective, SvgIconComponent } from './svg-icon.component';

/** Loved route module */
@NgModule({
    declarations: [SvgIconComponent, SafeSvgDirective],
    exports: [SvgIconComponent],
    imports: [
        CommonModule
        // BrowserModule
    ]
})
export class SvgIconModule { }
